/**
 * 手續費別 代碼
 */
export enum AreaType {

    /** 臺灣. */
    TW = 'TW',

    /** 香港. */
    HK = 'HK',

    /** 澳洲雪梨. */
    AU = 'AU',

    /** 緬甸. */
    MM = 'MM',

    /** 越南. */
    VN = 'VN',

    /** 柬埔寨. */
    KH = 'KH',

    /** 新加玻. */
    SG = 'SG',

    /** GIB-11816 美國. */
    US = 'US',

    /** 全區. */
    GLOBAL = 'GLOBAL'

}
